import { ref, set} from "firebase/database";
import { db} from "../../firebase";
import handleToast from "../Toast";

export const handleSaveHTMLEmbeddingNudge = (
    nudgeData,
    customizeState,
    nudgePosition,
    user,
    nudgeName
  ) => {
  // state of first time nudge to
  console.log("handleSaveHTMLEmbeddingNudge customizeState", customizeState)
    let state = {
      nudgeOfferText: {
        ...nudgeData.nudgeOfferText,
        customizeProperties: {
          ...nudgeData.nudgeOfferText.customizeProperties,
          text: {
            ...nudgeData.nudgeOfferText.customizeProperties.text,
            propertyValue: customizeState.nudgeOfferText.text,
          },
          textColor: {
            ...nudgeData.nudgeOfferText.customizeProperties.textColor,
            propertyValue: customizeState.nudgeOfferText.textColor,
          },
          fontStyle: {
            ...nudgeData.nudgeOfferText.customizeProperties.fontStyle,
            propertyValue: customizeState.nudgeOfferText.fontStyle,
          },
          isExpiryTimer: {
            ...nudgeData.nudgeOfferText.customizeProperties.isExpiryTimer,
            propertyValue: customizeState.nudgeOfferText.isExpiryTimer,
          },
          minutes: {
            ...nudgeData.nudgeOfferText.customizeProperties.minutes,
            propertyValue: customizeState.nudgeOfferText.minutes,
          },
          display: {
            ...nudgeData.nudgeOfferText.customizeProperties.display,
            propertyValue: customizeState.nudgeOfferText.display,
          },
        },
      },
      nudgeCopyCode: {
        ...nudgeData.nudgeCopyCode,
        customizeProperties: {
          ...nudgeData.nudgeCopyCode.customizeProperties,
          text: {
            ...nudgeData.nudgeCopyCode.customizeProperties.text,
            propertyValue: customizeState.nudgeCopyCode.text,
          },
          textColor: {
            ...nudgeData.nudgeCopyCode.customizeProperties.textColor,
            propertyValue: customizeState.nudgeCopyCode.textColor,
          },
          backgroundColor: {
            ...nudgeData.nudgeCopyCode.customizeProperties.backgroundColor,
            propertyValue: customizeState.nudgeCopyCode.backgroundColor,
          },
          fontStyle: {
            ...nudgeData.nudgeCopyCode.customizeProperties.fontStyle,
            propertyValue: customizeState.nudgeCopyCode.fontStyle,
          },
          borderStyle: {
            ...nudgeData.nudgeCopyCode.customizeProperties.borderStyle,
            propertyValue: customizeState.nudgeCopyCode.borderStyle,
          },
          borderColor: {
            ...nudgeData.nudgeCopyCode.customizeProperties.borderColor,
            propertyValue: customizeState.nudgeCopyCode.borderColor,
          },
          borderWidth: {
            ...nudgeData.nudgeCopyCode.customizeProperties.borderWidth,
            propertyValue: customizeState.nudgeCopyCode.borderWidth,
          },
          borderRadius: {
            ...nudgeData.nudgeCopyCode.customizeProperties.borderRadius,
            propertyValue: customizeState.nudgeCopyCode.borderRadius,
          },
          display: {
            ...nudgeData.nudgeCopyCode.customizeProperties.display,
            propertyValue: customizeState.nudgeCopyCode.display,
          },
          ...(nudgeData.nudgeCopyCode.customizeProperties.href && {
            href: {
                ...nudgeData.nudgeCopyCode.customizeProperties.href,
                propertyValue: customizeState.nudgeCopyCode.href,
            }
        }),
          // href: {
          //   ...nudgeData.nudgeCopyCode.customizeProperties.href,
          //   propertyValue: customizeState.nudgeCopyCode.href,
          // },
        },
      },
      nudge: {
        ...nudgeData.nudge,
        customizeProperties: {
          ...nudgeData.nudge.customizeProperties,
          backgroundColor: {
            ...nudgeData.nudge.customizeProperties.backgroundColor,
            propertyValue: customizeState.nudge.backgroundColor,
          },
          borderColor: {
            ...nudgeData.nudge.customizeProperties.borderColor,
            propertyValue: customizeState.nudge.borderColor,
          },
          borderStyle: {
            ...nudgeData.nudge.customizeProperties.borderStyle,
            propertyValue: customizeState.nudge.borderStyle,
          },
          borderWidth: {
            ...nudgeData.nudge.customizeProperties.borderWidth,
            propertyValue: customizeState.nudge.borderWidth,
          },
          borderRadius: {
            ...nudgeData.nudge.customizeProperties.borderRadius,
            propertyValue: customizeState.nudge.borderRadius,
          },
        },
        nudgePosition: {
          ...nudgeData.nudge.nudgePosition,
          desktop: {
            ...nudgeData.nudge.nudgePosition.desktop,
            top: nudgePosition.desktop.top,
            left: nudgePosition.desktop.left,
          },
          mobile: {
            ...nudgeData.nudge.nudgePosition.mobile,
            top: nudgePosition.mobile.top,
          },
        },
      },
      nudgeShowing: {
        ...nudgeData.nudgeShowing,
        customizeProperties: {
          ...nudgeData.nudgeShowing.customizeProperties,
          allowed: {
            ...nudgeData.nudgeShowing.customizeProperties.allowed,
            propertyValue: (customizeState.nudgeShowing.allowed === undefined || customizeState.nudgeShowing.allowed.length === 0 || customizeState.nudgeShowing.allowed === "") ? [] : customizeState.nudgeShowing.allowed
          },
          prohibited: {
            ...nudgeData.nudgeShowing.customizeProperties.prohibited,
            propertyValue: customizeState.nudgeShowing.prohibited
          },
          status: {
            ...nudgeData.nudgeShowing.customizeProperties.status,
            propertyValue: customizeState.nudgeShowing.status
          }, 
          firstTimeNudgeShown: {
            ...nudgeData.nudgeShowing.customizeProperties.firstTimeNudgeShown,
            propertyValue: customizeState.nudgeShowing.firstTimeNudgeShown
          }, 
          sensitivity: {
            ...nudgeData.nudgeShowing.customizeProperties.sensitivity,
            propertyValue: customizeState.nudgeShowing.sensitivity,
          },
          device: {
            ...nudgeData.nudgeShowing.customizeProperties?.device,
            propertyValue: customizeState.nudgeShowing.device,
          },
          nudgeTimeout: {
            ...nudgeData.nudgeShowing.customizeProperties?.nudgeTimeout,
            propertyValue: customizeState.nudgeShowing.nudgeTimeout,
          },
          Geolocation: {
            ...nudgeData.nudgeShowing.customizeProperties.Geolocation,
            propertyValue: customizeState.nudgeShowing.Geolocation,
          },
          audience: {
            ...nudgeData.nudgeShowing.customizeProperties.audience,
            propertyValue: customizeState.nudgeShowing.audience,
          },
          ...(nudgeData.nudgeShowing.customizeProperties.endDate && {
            endDate: {
                ...nudgeData.nudgeShowing.customizeProperties.endDate,
                propertyValue: customizeState.nudgeShowing.endDate,
            }
        }),
          ...(nudgeData.nudgeShowing.customizeProperties.nudgeActiveDays && {
            nudgeActiveDays: {
                ...nudgeData.nudgeShowing.customizeProperties.nudgeActiveDays,
                propertyValue: customizeState.nudgeShowing.nudgeActiveDays,
            },
        }),
          ...(nudgeData.nudgeShowing.customizeProperties.priority && {
            priority: {
                ...nudgeData.nudgeShowing.customizeProperties.priority,
                propertyValue: customizeState.nudgeShowing.priority,
            }
        }),
          ...(nudgeData.nudgeShowing.customizeProperties.GeoZipcodes && {
            GeoZipcodes: {
                ...nudgeData.nudgeShowing.customizeProperties.GeoZipcodes,
                propertyValue: customizeState.nudgeShowing.GeoZipcodes,
            },
        }),
          ...(nudgeData.nudgeShowing.customizeProperties.BlacklistedZipcodes && {
            BlacklistedZipcodes: {
                ...nudgeData.nudgeShowing.customizeProperties.BlacklistedZipcodes,
                propertyValue: customizeState.nudgeShowing.BlacklistedZipcodes,
            },
        }),
        ...(nudgeData.nudgeShowing.customizeProperties.seoKeyword && {
            seoKeyword: {
                ...nudgeData.nudgeShowing.customizeProperties.seoKeyword,
                propertyValue: customizeState.nudgeShowing.seoKeyword,
            },
        }),
        ...(nudgeData.nudgeShowing.customizeProperties.ipBasedNudgeControl && {
            ipBasedNudgeControl: {
                ...nudgeData.nudgeShowing.customizeProperties.ipBasedNudgeControl,
                propertyValue: customizeState.nudgeShowing.ipBasedNudgeControl,
            },
        }),
        ...(nudgeData.nudgeShowing.customizeProperties.firstTimeUserCheckingOptions && {
          firstTimeUserCheckingOptions: {
              ...nudgeData.nudgeShowing.customizeProperties.firstTimeUserCheckingOptions,
              propertyValue: customizeState.nudgeShowing.firstTimeUserCheckingOptions,
          },
        }),
          }
      },
      nudgeClosed: {
        ...nudgeData.nudgeClosed,
        customizeProperties: {
          ...nudgeData.nudgeClosed.customizeProperties,
          fontSize: {
            ...nudgeData.nudgeClosed.customizeProperties.fontSize,
            propertyValue: customizeState.nudgeClosed.fontSize
          },
          textColor: {
            ...nudgeData.nudgeClosed.customizeProperties.textColor,
            propertyValue: customizeState.nudgeClosed.textColor
          }, 
          topPosition: {
            ...nudgeData.nudgeClosed.customizeProperties.topPosition,
            propertyValue: customizeState.nudgeClosed.topPosition
          }, 
          rightPosition: {
            ...nudgeData.nudgeClosed.customizeProperties.rightPosition,
            propertyValue: customizeState.nudgeClosed.rightPosition,
          },
          display: {
            ...nudgeData.nudgeClosed.customizeProperties.display,
            propertyValue: customizeState.nudgeClosed.display,
          }
        }
      },
      nudgeTrafficSources: {
        ...nudgeData.nudgeTrafficSources,
        customizeProperties: {
          ...nudgeData.nudgeTrafficSources.customizeProperties,
          referrerSites: {
            ...nudgeData.nudgeTrafficSources.customizeProperties.referrerSites,
            propertyValue: (customizeState.nudgeTrafficSources.referrerSites === undefined || customizeState.nudgeTrafficSources.referrerSites.length === 0 || customizeState.nudgeTrafficSources.referrerSites === "") ? [] : customizeState.nudgeTrafficSources.referrerSites
          },
          queryParams: {
            ...nudgeData?.nudgeTrafficSources?.customizeProperties?.queryParams,
            propertyValue: (customizeState?.nudgeTrafficSources?.queryParams === undefined || customizeState?.nudgeTrafficSources?.queryParams?.length === 0 || customizeState?.nudgeTrafficSources?.queryParams === "") ? [] : customizeState?.nudgeTrafficSources?.queryParams
          },
          excludeReferrerSites: {
            ...nudgeData?.nudgeTrafficSources?.customizeProperties?.excludeReferrerSites,
            propertyValue: (customizeState?.nudgeTrafficSources?.excludeReferrerSites === undefined || customizeState?.nudgeTrafficSources?.excludeReferrerSites?.length === 0 || customizeState?.nudgeTrafficSources?.excludeReferrerSites === "") ? [] : customizeState?.nudgeTrafficSources?.excludeReferrerSites
          },
          }
      },
      mediaFields: {
        ...nudgeData.mediaFields,
        customizeProperties: {
          ...nudgeData.mediaFields.customizeProperties,
          mediaInputField_1: {
            ...nudgeData.mediaFields.customizeProperties.mediaInputField_1,
            propertyValue: customizeState.mediaFields.mediaInputField_1,
          },
          mediaInputField_2: {
            ...nudgeData.mediaFields.customizeProperties.mediaInputField_2,
            propertyValue: customizeState.mediaFields.mediaInputField_2,
          },
          mediaInputField_3: {
            ...nudgeData.mediaFields.customizeProperties.mediaInputField_3,
            propertyValue: customizeState.mediaFields.mediaInputField_3,
          },
          mediaType: {
            ...nudgeData.mediaFields.customizeProperties.mediaType,
            propertyValue: customizeState.mediaFields.mediaType,     
          },
          display: {
            ...nudgeData.mediaFields.customizeProperties.display,
            propertyValue: customizeState.mediaFields.display,
          },
          borderWidth: {
            ...nudgeData.mediaFields.customizeProperties.borderWidth,
            propertyValue: customizeState.mediaFields.borderWidth,
          },
          borderStyle: {
            ...nudgeData.mediaFields.customizeProperties.borderStyle,
            propertyValue: customizeState.mediaFields.borderStyle,
          },
          borderRadius: {
            ...nudgeData.mediaFields.customizeProperties.borderRadius,
            propertyValue: customizeState.mediaFields.borderRadius,
          },
          borderColor: {
            ...nudgeData.mediaFields.customizeProperties.borderColor,
            propertyValue: customizeState.mediaFields.borderColor,
          },
          backgroundColor: {
            ...nudgeData.mediaFields.customizeProperties.backgroundColor,
            propertyValue: customizeState.mediaFields.backgroundColor,
          },
        }
      },
      designPosition: {
        ...nudgeData.designPosition,
        customizeProperties: {
          ...nudgeData.designPosition.customizeProperties,
          fullXpath: {
            ...nudgeData.designPosition.customizeProperties?.fullXpath,
            propertyValue: customizeState.designPosition.fullXpath,
          },
          placement: {
            ...nudgeData.designPosition.customizeProperties?.placement,
            propertyValue: customizeState.designPosition.placement,
          }
          }
      },
      ...(customizeState.nudgeDisclaimerText && {
        nudgeDisclaimerText: {
          ...nudgeData.nudgeDisclaimerText,
          customizeProperties: {
            ...nudgeData.nudgeDisclaimerText.customizeProperties,
            text: {
              ...nudgeData.nudgeDisclaimerText.customizeProperties.text,
              propertyValue: customizeState.nudgeDisclaimerText.text,
            },
            textColor: {
              ...nudgeData.nudgeDisclaimerText.customizeProperties.textColor,
              propertyValue: customizeState.nudgeDisclaimerText.textColor,
            },
            fontStyle: {
              ...nudgeData.nudgeDisclaimerText.customizeProperties.fontStyle,
              propertyValue: customizeState.nudgeDisclaimerText.fontStyle,
            },
            fontSize: {
              ...nudgeData.nudgeDisclaimerText.customizeProperties.fontSize,
              propertyValue: customizeState.nudgeDisclaimerText.fontSize,
            },
            display: {
              ...nudgeData.nudgeDisclaimerText.customizeProperties.display,
              propertyValue: customizeState.nudgeDisclaimerText.display,
            },
          },
        },
      }),
      }
  
  // console.log("handleSaveLeadCapturedNudge -> state", state);
  // return;
  
    set(
      ref(db, `${user}/customise_nudge/userNudgeData/${nudgeName}`),
      state
    )
      .then(() => {
        handleToast("success", "Saved Successfully!");
      })
      .catch((err) => {
        console.log(err);
        handleToast("error", "Try after sometimes!");
      });
  };